import comp from "./ImageCoverUpload";
export default comp;
